import axios from '../../plugins/TradutorInterceptor'

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}

export const actions = {
    listaSetupConcessionarias(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('concessionarias' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    createSetupConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('concessionarias', payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    updateSetupConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('concessionarias/' + payload.id, payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    showSetupConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('concessionarias/' + payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    excluirSetupConcessionaria(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete('concessionarias/' + payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/setupConcessionarias.js